import React from 'react';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import 'moment-timezone';

import RichEditorContent from 'components/RichEditorContent';

import IntlDate from 'components/layout/IntlDate';
import IntlDateRelative from 'components/layout/IntlDateRelative';

class CommentCard extends React.Component {
  render() {
    const { intl, comment } = this.props;
    const messages = intl.messages;

    const momentWeekAgo = moment()
      .subtract(7, 'days')
      .startOf('day');
    const commentDate = moment(comment.getCdate()).isAfter(momentWeekAgo) ? (
      <IntlDateRelative date={comment.getCdate()} />
    ) : (
      <IntlDate date={comment.getCdate()} />
    );

    return (
      <div class="card share full-width">
        <div class="card-header clearfix">
          <div class="user-pic">
            <i class="fal fa-fw fa-user-circle text-master-light" style={{ fontSize: '33px' }} />
          </div>
          <h5>{comment.getCreatorName()}</h5>
          <h6>{messages.wrote_comment}</h6>
        </div>
        <div class="card-block" style={{ padding: '0 20px' }}>
          <RichEditorContent content={'<div>' + comment.getContent() + '</div>'} />
        </div>
        <div class="card-footer clearfix">
          <div class="time">{commentDate}</div>
        </div>
      </div>
    );
  }
}
CommentCard.defaultProps = {};

export default injectIntl(CommentCard);
